import { useBolaoTicker } from '../hooks/useBolaoTicker';

interface Props {
  telaId: string;
}

export default function TvBolaoTicker({ telaId }: Props) {
  const { apostas } = useBolaoTicker(telaId);

  if (apostas.length === 0) return null;

  return (
    <div className="fixed bottom-24 right-8 z-30 flex flex-col gap-3 items-end pointer-events-none">
      {apostas.map((aposta) => (
        <div
          key={aposta.id}
          className="animate-fade-in-up bg-black/80 backdrop-blur-md border border-amber-500/50 rounded-2xl p-4 shadow-[0_4px_20px_rgba(0,0,0,0.5),0_0_15px_rgba(245,158,11,0.2)] flex items-center gap-4"
        >
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center text-xl shadow-inner">
            🎰
          </div>
          <div className="flex flex-col">
            <span className="text-white/60 uppercase tracking-widest text-xs font-bold">
              Nova Aposta: {aposta.identificacao}
            </span>
            <div className="flex items-center gap-2 mt-0.5">
              <span className="text-white font-black text-2xl tabular-nums">
                {aposta.palpite_casa}
              </span>
              <span className="text-amber-500 font-black text-xl">×</span>
              <span className="text-white font-black text-2xl tabular-nums">
                {aposta.palpite_visitante}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
